function resolveApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_URL?.trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  // Dev: relative URLs use CRA proxy (package.json → localhost:5050)
  if (process.env.NODE_ENV === "development") return "";
  return "https://api.lettingengine.com";
}

export const API_BASE_URL = resolveApiBaseUrl();
